export default "__VITE_ASSET__319180f0__"